import {
  ActivityFilterType,
  requestParamsByActivityFilterType,
} from "~/feature/dashboard/components/sortAndFilters/StatusFilterDropdown/config";

interface IGetActivityFilterValueProps {
  active?: boolean;
  resolved?: boolean;
}

export const getActivityFilterValue = (value: IGetActivityFilterValueProps) => {
  const matched = Object.values(ActivityFilterType).find((type) => {
    const requestParams = requestParamsByActivityFilterType[type];
    return (
      requestParams.active === value.active &&
      requestParams.resolved === value.resolved
    );
  });
  return matched ?? null;
};
